import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "clienteFilter",
})
export class ClienteFilterPipe implements PipeTransform {
  transform(clientes: any[], texto: string): any[] {
    if (!clientes) return [];
    if (!texto) return clientes;

    texto = texto.toLowerCase().trim();

    return clientes.filter((cli) => cli.ttNombr.toLowerCase().includes(texto));
  }
}
